import { FieldLogo } from '../../components/index.js';

/**
 * NFL Flag field dimensions:
 *  30 x 70 (yards)
 *
 *  Longitudinal layout (along y):
 *    0-10   endzone
 *    10-15  no-running zone
 *    15-30  open field
 *    30-40  midfield no-running zone
 *    40-55  open field
 *    55-60  no-running zone
 *    60-70  endzone
 */
const FlagFullFieldBackdrop: FC<any> = ({ fieldViewport, backgroundImage }) => {
    const fieldWidth = 30;
    const fieldHeight = 70;

    const goalLineTop = 10;
    const goalLineBottom = 60;
    const noRunNearTop = 15;
    const noRunMidTop = 30;
    const noRunMidBottom = 40;
    const noRunNearBottom = 55;

    const yardLines: number[] = [];
    for (let yard = goalLineTop; yard <= goalLineBottom; yard += 5) {
        yardLines.push(yard);
    }

    return (
        <g className="field-backdrop">
            <rect
                x={fieldViewport.flippedX ? fieldViewport.getPixelX(fieldWidth) : fieldViewport.getPixelX(0)}
                y={fieldViewport.flipped ? fieldViewport.getPixelY(fieldHeight) : fieldViewport.getPixelY(0)}
                width={fieldViewport.getPixelLength(fieldWidth)}
                height={fieldViewport.getPixelLength(fieldHeight)}
                fill="none"
            />

            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: 5, y: (noRunNearTop + noRunMidTop) / 2 }}
                size={7}
                rotation={90}
            />
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: fieldWidth - 5, y: (noRunNearTop + noRunMidTop) / 2 }}
                size={7}
                rotation={-90}
            />
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: 5, y: (noRunMidBottom + noRunNearBottom) / 2 }}
                size={7}
                rotation={90}
            />
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: fieldWidth - 5, y: (noRunMidBottom + noRunNearBottom) / 2 }}
                size={7}
                rotation={-90}
            />

            {yardLines.map((yard) => (
                <line
                    key={yard}
                    x1={fieldViewport.getPixelX(0)}
                    y1={fieldViewport.getPixelY(yard)}
                    x2={fieldViewport.getPixelX(fieldWidth)}
                    y2={fieldViewport.getPixelY(yard)}
                />
            ))}

            <text
                dx={fieldViewport.flippedX ? fieldViewport.getPixelX(0) - 5 : fieldViewport.getPixelX(fieldWidth) - 5}
                dy={fieldViewport.flipped ? fieldViewport.getPixelY(0) - 5 : fieldViewport.getPixelY(fieldHeight) - 5}
                textAnchor="end"
                strokeWidth="0"
                fill="#aaa"
                fontSize=".8em"
            >
                FootballLab.com
            </text>
        </g>
    );
};

export default FlagFullFieldBackdrop;
